export const FLAG_GETTING_EXPENSE_AUTHORIZER_USERS =
  'FLAG_GETTING_EXPENSE_AUTHORIZER_USERS';
export const GET_EXPENSE_AUTHORIZER_USERS = 'GET_EXPENSE_AUTHORIZER_USERS';
export const CLEAR_EXPENSE_AUTHORIZER_USERS = 'CLEAR_EXPENSE_AUTHORIZER_USERS';
export const FLAG_EXPENSE_AUTHORIZER_USER_ACTIVITY =
  'FLAG_EXPENSE_AUTHORIZER_USER_ACTIVITY';
export const GET_EXPENSE_AUTHORIZER_USER = 'GET_EXPENSE_AUTHORIZER_USER';
export const CLEAR_EXPENSE_AUTHORIZER_USER = 'CLEAR_EXPENSE_AUTHORIZER_USER';
